import type { PageProps } from 'gatsby';
import React from 'react';
import { useIntl, defineMessages } from 'react-intl';

import MainTitle from '@components/MainTitle';

import { useIsMobile } from '@hooks/useIsMobile';

import AppLayout from '@layouts/AppLayout';
import { MainContainer } from '@layouts/DrilldownStyle';

import MainWrapper from '@views/Records/Common/MainWrapper';
import ShareHistoryList from '@views/SharedResource/List/ShareHistoryList';

const messages = defineMessages({
  title: {
    id: 'shareHistory.title',
    defaultMessage: 'Share History',
  },
});

export default function ShareHistoryPage({ params }: PageProps) {
  const { formatMessage } = useIntl();
  const isMobile = useIsMobile();

  return isMobile ? (
    <AppLayout friendlyName={formatMessage(messages.title)} showHeader>
      <MainContainer maxWidth="600px">
        <MainTitle title={formatMessage(messages.title)} />
        <ShareHistoryList {...params} />
      </MainContainer>
    </AppLayout>
  ) : (
    <MainWrapper
      friendlyName={formatMessage(messages.title)}
      title={formatMessage(messages.title)}
    >
      <ShareHistoryList {...params} />
    </MainWrapper>
  );
}
